import * as React from "react";
import Text from "src/components/text/Text";
import TextLink from "src/components/text/TextLink";

export interface IAgentErrorProps {
  sessionId: string;
  eventId?: string;
}

const AgentError: React.FunctionComponent<IAgentErrorProps> = ({ sessionId, eventId }) => {
  const hasEventId = eventId && eventId.trim();
  const subTextId = hasEventId ? 'SubTextWithEventId' : 'SubText';
  const referenceId = hasEventId ? eventId : sessionId;

  return (
    <div className="agent-error">
      <h2>
        <Text category="ErrorAgent" id="Header" />
      </h2>
      <p>
        <TextLink
          category="ErrorAgent"
          id={subTextId}
          href="ContactUsLoginIssue"
          substitutionData={{ ReferenceId: referenceId }}
        />
      </p>
    </div>
  );
};

export default AgentError;
